module.exports = __webpack_public_path__ + "img/sample-dataAnalyst.c59d032d.webp";